// extracted by mini-css-extract-plugin
module.exports = {"content":"notification_content__pDSpK","body":"notification_body__POslX","oneliner":"notification_oneliner__VlJbF","twoliner":"notification_twoliner__tYXr_"};